<template>
  <div>
    <div class="row" style="margin-top: 25px">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.create_annually_inform}}</strong>
          </div>
          <div class="card-block">
            <form id="energetic-inform" enctype="multipart/form-data" class="form-horizontal">
               <div class="form-group row">
                <div class="col-lg-3 form-group"></div>
                <div class="col-lg-6 form-group">
                  <label>{{web_texts.date_range}}</label>
                  <div class="input-prepend input-group col-xlg-12 col-md-12 col-sm-12 col-xs-12">
                    <span class="add-on input-group-addon"><i class="glyphicon glyphicon-calendar fa fa-calendar"></i></span>
                    <input type="text" name="daterange" id="daterange" class="form-control input-lg"/>
                  </div>
                </div>
               </div>
            </form>
          </div>
          <div class="card-footer">
            <div class="offset-lg-4 col-lg-4">
              <button type="submit" @click="createEnergeticInform()" class="btn btn-sm btn-primary" :disabled="spinner_electrical_summary"><i class="fa fa-dot-circle-o"></i>{{web_texts.create}}</button>
              <button type="reset" @click="resetEnergeticForm()" class="btn btn-sm btn-danger" :disabled="spinner_electrical_summary"><i class="fa fa-ban"></i>Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 25px">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.annually_inform}}</strong>
          </div>
          <GeneralSpinner v-if="spinner_electrical_summary"></GeneralSpinner>
          <div class="card-block" v-else="">
            <vue-good-table :columns="columns" :rows="invoices" :paginate="true" :perPage="5">
              <template slot="table-row" slot-scope="props">
                <td>{{ "Informe Anual" }}</td>
                <td>{{ props.row.start_datetime }}</td>
                <td>{{ props.row.end_datetime }}</td>
                <td style="text-align: center">
                  <button type="button" class="btn btn-primary" @click="downloadInvoice(props.row.id)"><i class="fa fa-file-pdf-o"></i></button>
                  <button  v-if="props.row.user_id!==2" type="button" class="btn btn-danger " @click="deleteInformApi(props.row.id)"><i class="fa fa-trash-o"></i></button>
                </td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/AnuallSumary';
  import trans_es from '../translates/es/AnuallSumary';
  import constants from '../constants'
  import middleware from '../utilities/middlewares'
  import modal from 'vue-strap/src/Modal'
  import GeneralSpinner from './partials/GeneralSpinner.vue';
  import date_interval from '../utilities/dates_intervals'

  export default {
    name: '',
    data() {
      return {
        spinner_electrical_summary: true,
        web_texts: { "create_annually_inform": "Crear Informe Anual", "date_range": "Rang de dates", "create": "Crear", "annually_inform": "Informe Anual" },
        slave_type: '',
        slave_types: '',
        device: '',
        devices: '',
        user_name: '',
        user_id: '',
        showInvoiceModal: false,
        months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Stembre', 'Octubre', 'Novembre', 'Desembre'],
        captions: {'ok_button': 'Seleccionar'},
        shortDays: ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
        invoices: '',
        auxiliary_array: [],
        columns: [
          {
            label: 'Name',
            field: 'name',
            html: true
          },
          {
            label: 'Start Date',
            field: 'start_datetime',
            html: true
          },
          {
            label: 'Final Date',
            field: 'end_datetime',
            html: true
          },
          {
            label: 'Actions',
            field: 'actions',
            html: true
          }
        ]
      }
    },
    components: {
      modal,
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["electrical_summary","electrical_summary"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system = JSON.parse(localStorage.getItem('system'));
      this.user_name = JSON.parse(localStorage.getItem('user')).name;
      this.user_id = JSON.parse(localStorage.getItem('user')).id;
      this.getReportsTable();
    },
    mounted(){
      // inicialitzem daterangepicker
      this.initializeDateRangePicker();
    },
    methods: {
      // Llegir les simulacions de factures
      getReportsTable() {
        axios.post(constants.ROOT_URL + '/api/v1/get_informs', {
          system_id: this.system.id,
          inform_type: 'electrical_summary',
          client_device: 'd'
        }).then((response) => {
          this.invoices=response.data;
          this.spinner_electrical_summary=false;
        }, (response) => {
          this.spinner_electrical_summary=false;
          console.log(response.data);
        });
      },
      // Descargar una simulacio de factura en pdf
      downloadInvoice(id) {
        this.spinner_electrical_summary=true;
        axios.get(constants.ROOT_URL + "/api/v1/pdf/electrical_summary/" + id, {
          responseType: 'arraybuffer'
        }).then((response) => {
          this.spinner_electrical_summary=false;
          var file = new File([response.data], "Electrical_Summary_"+id+".pdf", {type: "application/pdf"});
          FileSaver.saveAs(file);
        }, (response) => {
          console.log(response);
        });
      },
      createEnergeticInform(){
        this.spinner_electrical_summary=true;
        if(document.getElementById('daterange').value!=='-') {
          axios.post(constants.ROOT_URL + '/api/v1/create_inform', {
            system_id: this.system.id,
            inform_type: 'electrical_summary',
            date_range: document.getElementById('daterange').value,
            client_device: 'd'
          }).then((response) => {
            console.log(response.data);
            this.getReportsTable();
            swal({type: 'success', title: 'Informe creat correctament'})
          }, (response) => {
            this.spinner_electrical_summary=false;
            console.log(response.data);
          });
        }else{
          this.spinner_electrical_summary=false;
          swal({type: 'error', title: 'Falta Informació'})
        }
      },
      resetEnergeticForm(){
        location.reload();
      },
      // Eliminar un informe de costos
      deleteInformApi(id) {
        this.spinner_electrical_summary=true;
        axios.post(constants.ROOT_URL + '/api/v1/delete_inform', {
          system_id: this.system.id,
          inform_id: id,
          client_device: 'd'
        }).then((response) => {
          console.log(response.data);
          this.getReportsTable();
        }, (response) => {
          console.log(response.data);
        });
      },
      // Funcio per a que funcione el datepicker
      initializeDateRangePicker(){
        $(function() {
          var date = new Date();
          var month = date.getMonth();
          var year = date.getFullYear();
          $('input[name="daterange"]').daterangepicker({
            "locale": {
              "format": "MM/YYYY",
              "separator": " - ",
              "applyLabel": "Acceptar",
              "cancelLabel": "Cancel·lar",
              "fromLabel": "Des de",
              "toLabel": "Fins",
              "customRangeLabel": "Custom",
              "weekLabel": "W",
              "monthNames": [
                "Gener",
                "Febrer",
                "Març",
                "Abril",
                "Maig",
                "Juny",
                "Juliol ",
                "Agost ",
                "Setembre",
                "Octubre",
                "Novembre",
                "Desembre"
              ],
              "firstDay": 1
            },
            "startDate": (month+1)+"/"+year,
            "endDate": (month+1)+"/"+year
          })
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// AnuallSumary.vue?dd6a8696